<template>
	<nav class="cnt-gid-group">
		<item-empresa
			v-for="(empresa, id) in itens"
			:key="id"
			:data="empresa"
		/>
	</nav>
</template>
<script>
	// import LoadFunctions from './js/loadFunctions.mixin.js'
	import AgroupFunctions from './js/AgroupFunctions.mixin.js';

	import ItemEmpresa from './components/item-empresa.vue';

	export default {
		props: ['preRequestData', 'totalRegistros'],
		components: {
			ItemEmpresa,
		},
		mixins: [
			// LoadFunctions,
			AgroupFunctions,
		],
	};
</script>
<style scoped>
	.cnt-gid-group {
		padding: 18px 0 0 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/ModeAgroup/index.vue